import LazyLoadImage from "./LazyLoad";
export default LazyLoadImage;

export { default as Placeholder } from "./Placeholder";
